export const usStatesandProvinces = [
  { recordName: 'Alabama', abbreviation: 'AL' },
  { recordName: 'Alaska', abbreviation: 'AK' },
  { recordName: 'Alberta', abbreviation: 'AB' },
  { recordName: 'American Samoa', abbreviation: 'AS' },
  { recordName: 'Arizona', abbreviation: 'AZ' },
  { recordName: 'Arkansas', abbreviation: 'AR' },
  { recordName: 'British Columbia', abbreviation: 'BC' },
  { recordName: 'California', abbreviation: 'CA' },
  { recordName: 'Colorado', abbreviation: 'CO' },
  { recordName: 'Connecticut', abbreviation: 'CT' },
  { recordName: 'Delaware', abbreviation: 'DE' },
  { recordName: 'District Of Columbia', abbreviation: 'DC' },
  { recordName: 'Federated States Of Micronesia', abbreviation: 'FM' },
  { recordName: 'Florida', abbreviation: 'FL' },
  { recordName: 'Georgia', abbreviation: 'GA' },
  { recordName: 'Guam', abbreviation: 'GU' },
  { recordName: 'Hawaii', abbreviation: 'HI' },
  { recordName: 'Idaho', abbreviation: 'ID' },
  { recordName: 'Illinois', abbreviation: 'IL' },
  { recordName: 'Indiana', abbreviation: 'IN' },
  { recordName: 'Iowa', abbreviation: 'IA' },
  { recordName: 'Kansas', abbreviation: 'KS' },
  { recordName: 'Kentucky', abbreviation: 'KY' },
  { recordName: 'Louisiana', abbreviation: 'LA' },
  { recordName: 'Maine', abbreviation: 'ME' },
  { recordName: 'Manitoba', abbreviation: 'MB' },
  { recordName: 'Marshall Islands', abbreviation: 'MH' },
  { recordName: 'Maryland', abbreviation: 'MD' },
  { recordName: 'Massachusetts', abbreviation: 'MA' },
  { recordName: 'Michigan', abbreviation: 'MI' },
  { recordName: 'Minnesota', abbreviation: 'MN' },
  { recordName: 'Mississippi', abbreviation: 'MS' },
  { recordName: 'Missouri', abbreviation: 'MO' },
  { recordName: 'Montana', abbreviation: 'MT' },
  { recordName: 'Nebraska', abbreviation: 'NE' },
  { recordName: 'Nevada', abbreviation: 'NV' },
  { recordName: 'New Brunswick', abbreviation: 'NB' },
  { recordName: 'New Hampshire', abbreviation: 'NH' },
  { recordName: 'New Jersey', abbreviation: 'NJ' },
  { recordName: 'New Mexico', abbreviation: 'NM' },
  { recordName: 'New York', abbreviation: 'NY' },
  { recordName: 'Newfoundland and Labrador', abbreviation: 'NL' },
  { recordName: 'North Carolina', abbreviation: 'NC' },
  { recordName: 'North Dakota', abbreviation: 'ND' },
  { recordName: 'Northern Mariana Islands', abbreviation: 'MP' },
  { recordName: 'Northwest Territories', abbreviation: 'NT' },
  { recordName: 'Nova Scotia', abbreviation: 'NS' },
  { recordName: 'Nunavut', abbreviation: 'NU' },
  { recordName: 'Ohio', abbreviation: 'OH' },
  { recordName: 'Oklahoma', abbreviation: 'OK' },
  { recordName: 'Ontario', abbreviation: 'ON' },
  { recordName: 'Oregon', abbreviation: 'OR' },
  { recordName: 'Palau', abbreviation: 'PW' },
  { recordName: 'Pennsylvania', abbreviation: 'PA' },
  { recordName: 'Prince Edward Island', abbreviation: 'PE' },
  { recordName: 'Puerto Rico', abbreviation: 'PR' },
  { recordName: 'Quebec', abbreviation: 'QC' },
  { recordName: 'Rhode Island', abbreviation: 'RI' },
  { recordName: 'Saskatchewan', abbreviation: 'SK' },
  { recordName: 'South Carolina', abbreviation: 'SC' },
  { recordName: 'South Dakota', abbreviation: 'SD' },
  { recordName: 'Tennessee', abbreviation: 'TN' },
  { recordName: 'Texas', abbreviation: 'TX' },
  { recordName: 'Utah', abbreviation: 'UT' },
  { recordName: 'Vermont', abbreviation: 'VT' },
  { recordName: 'Virgin Islands', abbreviation: 'VI' },
  { recordName: 'Virginia', abbreviation: 'VA' },
  { recordName: 'Washington', abbreviation: 'WA' },
  { recordName: 'West Virginia', abbreviation: 'WV' },
  { recordName: 'Wisconsin', abbreviation: 'WI' },
  { recordName: 'Wyoming', abbreviation: 'WY' },
  { recordName: 'Yukon Territory', abbreviation: 'YT' },
];
